'use strict';

const Mn = require('backbone.marionette');
const URLCopyFooterTemplate = require('data/ui/template/modal/url-copy-footer.hbs');
const i18n = require('i18next');

module.exports = Mn.View.extend({
    template: URLCopyFooterTemplate,
    triggers: {
        'click .cancel': 'cancel',
        'click .copy-url': 'copy'
    },

    showTooltip: function() {
        const copyURLTooltip = this.$('[data-toggle="tooltip"]');
        copyURLTooltip.tooltip({
            title: i18n.t('data:content.copyURL.copied'),
        });
        copyURLTooltip.tooltip('show');
        this.hideTooltip();
    },

    hideTooltip: function() {
        const copyURLTooltip = this.$('[data-toggle="tooltip"]');
        setTimeout(function() {
            copyURLTooltip.tooltip('hide');
        }, 2000);
    }
});



// WEBPACK FOOTER //
// ./data/ui/view/modal/url-copy-footer.js